import { useMutation } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useUploadPrivateFileMutation = (options = {}) => {
  const api = useVTApiClient('privateFiles')
  return useMutation({
    mutationFn: async ({ file }) => {
      return api.upload({ file })
    },
    ...options
  })
}
